// Billionaires by Country - Ranked by Number of Billionaires
// Difficulty: DIFFICULT - Global economics knowledge required

export const billionairesData = [
  { id: 1, name: "The U.S.", rank: 1, image: "/images/billionaires/the_us.png" },
  { id: 2, name: "China", rank: 2, image: "/images/billionaires/china.png" },
  { id: 3, name: "India", rank: 3, image: "/images/billionaires/india.png" },
  { id: 4, name: "Germany", rank: 4, image: "/images/billionaires/germany.png" },
  { id: 5, name: "U.K.", rank: 5, image: "/images/billionaires/uk.png" },
  { id: 6, name: "Switzerland", rank: 6, image: "/images/billionaires/switzerland.png" },
  { id: 7, name: "Hong Kong\nSAR", rank: 7, image: "/images/billionaires/hong_kong_sar.png" },
  { id: 8, name: "Italy", rank: 8, image: "/images/billionaires/italy.png" },
  { id: 9, name: "Singapore", rank: 9, image: "/images/billionaires/singapore.png" },
  { id: 10, name: "Taiwan", rank: 10, image: "/images/billionaires/taiwan.png" },
  { id: 11, name: "Brazil", rank: 11, image: "/images/billionaires/brazil.png" },
  { id: 12, name: "Canada", rank: 12, image: "/images/billionaires/canada.png" },
  { id: 13, name: "France", rank: 13, image: "/images/billionaires/france.png" },
  { id: 14, name: "Australia", rank: 14, image: "/images/billionaires/australia.png" },
  { id: 15, name: "Japan", rank: 15, image: "/images/billionaires/japan.png" },
  { id: 16, name: "Israel", rank: 16, image: "/images/billionaires/israel.png" },
  { id: 17, name: "Spain", rank: 17, image: "/images/billionaires/spain.png" },
  { id: 18, name: "South\nKorea", rank: 18, image: "/images/billionaires/south_korea.png" },
  { id: 19, name: "Sweden", rank: 19, image: "/images/billionaires/sweden.png" },
  { id: 20, name: "Indonesia", rank: 20, image: "/images/billionaires/indonesia.png" },
  { id: 21, name: "Thailand", rank: 21, image: "/images/billionaires/thailand.png" },
  { id: 22, name: "Mexico", rank: 22, image: "/images/billionaires/mexico.png" },
  { id: 23, name: "Saudi\nArabia", rank: 23, image: "/images/billionaires/saudi_arabia.png" },
  { id: 24, name: "United Arab\nEmirates", rank: 24, image: "/images/billionaires/united_arab_emirates.png" },
  { id: 25, name: "Philippines", rank: 25, image: "/images/billionaires/philippines.png" },
  { id: 26, name: "Malaysia", rank: 26, image: "/images/billionaires/malaysia.png" },
  { id: 27, name: "Norway", rank: 27, image: "/images/billionaires/norway.png" },
  { id: 28, name: "Austria", rank: 28, image: "/images/billionaires/austria.png" },
  { id: 29, name: "Denmark", rank: 29, image: "/images/billionaires/denmark.png" },
  { id: 30, name: "Netherlands", rank: 30, image: "/images/billionaires/netherlands.png" },
];
